<template>
  <!-- -->
  <div class="image-data-setting mini-component">
    <div class="desc">
      服务组件是系统组件，不能自定义内容，服务卡片只的功能可能根据商户开通的服务不同而不同
    </div>
    <div>
      服务组件的配置只能进行开关，组件配置背景色和图片会失效，组件配置的圆角只对卡片类有效，边距可正常使用，如果要配置服务功能，请前往小程序服务功能
    </div>
  </div>
</template>

<script>

import AloneData from "@/views/h5/common/sys/miniProgram/setting/component/AloneData.vue";
export default {
  emits: ["change"],
  props: {
    data: {
      type: Object,
      default: () => {
        return {componentData: {}}
      }
    }
  },
  name: "",
  components: {
    AloneData
  },
  data() {
    return {
      settingData: {},
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      if (!this.data.componentData) {
        this.settingData = {size: ""};
      } else {
        this.settingData = this.data.componentData;
      }
    },
    changeData() {
      this.$emit("change", {...this.data, componentData: this.settingData});
    }
  }
};
</script>

<style lang="scss" scoped>
.image-data-setting{

}
</style>